import { fetchJson, fetchResponse } from "src/utils/apiUtils";
import {
  AdminUserId as ID,
  IAdminUser as Entity,
  IAdminUserPaginateReq as PaginateReq,
  IAdminUserSaveReq as SaveReq,
  IAdminUserUpdateReq as UpdateReq,
  IAdminUserChangePasswordReq as ChangePasswordReq
} from "./types";

const endpoint = "adminUser";

export const list = async (req: PaginateReq) => {
  return fetchJson<IResponse<IPaginateResponse<Entity>>>(
    `${endpoint}/listPaginate`,
    {
      method: "POST",
      body: JSON.stringify({ ...req })
    }
  );
};

export const get = async (id: ID) => {
  return fetchJson<IResponse<Entity>>(`${endpoint}/${id}`, {
    method: "GET"
  });
};

export const save = async (req: SaveReq) => {
  return fetchJson<IResponse<ID>>(`${endpoint}/save`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const update = async (id: ID, req: UpdateReq) => {
  return fetchJson<IResponse<Entity>>(`${endpoint}/update/${id}`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const changePassword = async (id: ID, req: ChangePasswordReq) => {
  return fetchResponse(`${endpoint}/changePassword/${id}`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};
